import { makeStyles } from "@mui/styles";
import { colors, Commons } from "../../styleguide";

const styles = makeStyles(() => ({
  promoBanner: {
    ...Commons.coverBackground,
    ...Commons.flexRow,
    position: "relative",
    alignItems: "center",
    backgroundImage:
      "url(https://firebasestorage.googleapis.com/v0/b/froin-club.appspot.com/o/company%2Fbg_tetris.jpeg?alt=media&token=c2b39797-41b3-4928-9ae9-1ef70e214dd9)",
    marginBottom: 60,
    borderRadius: 18,
    overflow: "hidden",
    animation: "$neonPromoBgLoop 3s linear infinite",
    [Commons.midQuery]: {
      flexDirection: "column",
    },
  },
  blurPromoBanner: {
    position: "absolute",
    top: 0,
    left: 0,
    zIndex: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0 ,0, 0, 0.75)",
  },
  leftPromoBanner: {
    position: "relative",
    flex: 1,
    ...Commons.flexColumn,
    gap: 12,
    "& p:nth-child(1)": {
      color: colors.white,
      fontSize: 36,
      textAlign: "center",
      fontWeight: 600,
      margin: "0 0 12px 0",
      fontFamily: "'Rubik Glitch', system-ui !important",
      [Commons.midQuery]: {
        margin: "24px 0 12px 0",
        fontSize: 30,
      },
    },
    "& p:nth-child(2)": {
      color: colors.white,
      fontSize: 18,
      textAlign: "center",
      fontWeight: 500,
      margin: 0,
      lineHeight: "18px",
      fontFamily: "'Rubik Glitch', system-ui !important",
      [Commons.midQuery]: {
        fontSize: 16,
      },
    },
    "& span": {
      color: "#d64ec7",
      fontSize: 36,
      fontWeight: 600,
      fontFamily: "'Rubik Glitch', system-ui !important",
      [Commons.midQuery]: {
        fontSize: 30,
      },
    },
  },
  imagePromoBanner: {
    position: "relative",
    width: 240,
    aspectRatio: "1 / 1",
    objectFit: "cover",
    border: "6px solid #d64ec7",
    margin: "24px 0",
    [Commons.midQuery]: {
      width: 180,
    },
  },
  rightPromoBanner: {
    position: "relative",
    ...Commons.flexColumn,
    flex: 1,
    "& p": {
      color: colors.white,
      fontSize: 30,
      textAlign: "center",
      fontWeight: 600,
      fontFamily: "'Rubik Glitch', system-ui !important",
      margin: 0,
      [Commons.midQuery]: {
        fontSize: 24,
      },
    },
  },
  rowPlatformsPromoBanner: {
    ...Commons.flexRow,
    alignItems: "center",
    justifyContent: "center",
    flexWrap: "wrap",
    gap: 18,
    marginTop: 18,
    "& img": {
      height: 30,
      width: "auto",
      cursor: "pointer",
    },
    [Commons.midQuery]: {
      marginBottom: 30,
    },
  },
  "@keyframes neonPromoBgLoop": {
    "0%": {
      boxShadow: `0 0 50px 3px #d64ec730`,
    },
    "50%": {
      boxShadow: `0 0 50px 3px #d64ec7`,
    },
    "100%": {
      boxShadow: `0 0 50px 3px #d64ec730`,
    },
  },
}));

export default styles;
